module.exports = __webpack_public_path__ + "img/Icon_1.41fc077b.png";